module.exports = __webpack_public_path__ + "media/Components/fonts/PTSans-334e18134af8ff169983ff1e4576e0ca.ttf";